// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                           from 'firebase/functions';

// ===== Enums =====

import {
    MEDIA_TYPE,
}                           from '../enums';

const updateMedia = async ({
    test,
    mediaId,
    type,
    title,
    description,
    caption,
    url,
    filePath,
    playsToAdd,
    clicksToAdd,
    isPostContentDictation,
    dictationSourceText,
    durationMs,
    waveformBars,
}: {
    test: boolean,
    mediaId: string,
    type: MEDIA_TYPE,
    title?: string,
    description?: string,
    caption?: string,
    url?: string,
    filePath?: string,
    playsToAdd?: string[],
    clicksToAdd?: string[],
    isPostContentDictation?: boolean,
    dictationSourceText?: string,
    durationMs?: number,
    waveformBars?: number[],
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateMedia = httpsCallable<
        Record<
            string,
            boolean | string | MEDIA_TYPE | number | string[] | number[] | undefined
        >,
        boolean
    >(
        functions,
        'updateMedia',
    );
    return handleUpdateMedia({
        test,
        mediaId,
        type,
        title,
        description,
        caption,
        url,
        filePath,
        playsToAdd,
        clicksToAdd,
        isPostContentDictation,
        dictationSourceText,
        durationMs,
        waveformBars,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateMedia;
